import { Alert, Button, Row, message } from 'antd';
import PropTypes from 'prop-types';
import React, { Component, forwardRef } from 'react';
import Matchable from '../../../components/Delights/Matchable/Matchable';
import { changePreviousDevData, delightToShow } from '../../../components/Delights/util';
import { getGCSUrl } from '../../../services/Common';
import { pushLog2DV2LogServer } from '../../../services/logging';
import { FolderOpenIcon, LanguagesIcon, PersonalIcon, SaveIcon, ScatterPlotIcon, SchoolIcon, WorkExperienceIcon } from '../../components/common/CustomIcon';
import CERTIFICATION_STATUS from '../../constants/cloudCertificationStatus';
import StatusBadge from '../shared/StatusBadge/StatusBadge';
import AdditionalInformationForm from './components/AdditionalInformationForm';
import EducationForm from './components/EducationForm';
import LanguagesForm from './components/LanguagesForm';
import PersonalInformationForm from './components/PersonalInformationForm';
import PreviewProfileButton from './components/PreviewProfileButton';
import RequiredActionCollapse from './components/RequiredActionCollapse';
import ResumeUploadedConfirmation from './components/ResumeUpload/ResumeUploadedConfirmation';
import SideProjectsForm from './components/SideProjectsForm';
import TuringCollapse, { TuringCollapseV2 } from './components/TuringCollapse';
import WorkHistoryForm from './components/WorkHistoryForm';
import './FinalizeResumeV2.css';
import withFinalizeResumeV2Service from './FinalizeResumeV2.service';
import { withLDFlagsFromBackend, GB_FLAGS } from '../../services/launchDarkly';

class FinalizeResumeV2 extends Component {
  state = {
    startTime: null,
    showAlert: false,
    activePanel: ''
  };

  panelRefs = {
    personalinformation: React.createRef(),
    workhistory: React.createRef(),
    sideprojects: React.createRef(),
    education: React.createRef(),
    languages: React.createRef(),
    additionalinformation: React.createRef()
  };

  panelActiveMap = {
    personalinformation: 'PersonalInformation',
    workhistory: 'WorkHistory',
    sideprojects: 'SideProjects',
    education: 'Education',
    languages: 'languages',
    additionalinformation: 'AdditionalInformation'
  }

  componentDidMount() {
    this.setState({ startTime: (new Date()).getTime() });
    if (!localStorage.getItem('RESUME_BUILDER_VISIT')) {
      localStorage.setItem('RESUME_BUILDER_VISIT', '1');
      pushLog2DV2LogServer.info('RESUME_BUILDER_VISIT', 'RESUME_BUILDER_VISIT', {}, {});
    }

    const { tests } = this.props.service.props.store;
    changePreviousDevData(tests.turingProfileCompleted, "turingProfileCompleted");
  }

  componentDidUpdate(prevProps) {
    const prevFlag = prevProps.LDFlags.enable_language_quiz;
    const currFlag = this.props.LDFlags.enable_language_quiz;
  
    if (!prevFlag && currFlag) {
      const queryParams = new URLSearchParams(this.props?.service?.props?.location?.search);
      const activePanel = queryParams?.get('active')?.toLowerCase();
      if (activePanel && this.panelRefs[activePanel]) {
        this.props.service?.onPanelSelect(this.panelActiveMap[activePanel]);
        this.setState({ activePanel }, () => {
          const ref = this.panelRefs[activePanel];
          if (ref?.current) {
            try {
              ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } catch (e) {
              ref.current.scrollIntoView();
            }
          }
        });
      }
    }
  }
  
  

  componentWillUnmount() {
    if (this.state.startTime) {
      const time = Math.ceil(((new Date()).getTime() - this.state.startTime) / 1000);
      pushLog2DV2LogServer.info('RESUME_BUILDER_TIME_SPENT', 'RESUME_BUILDER_TIME_SPENT', {}, { time, unit: 'second' });
    }
  }

  uploadResume = (file, replaceData) => {
    const { service } = this.props;
    const { uploadResumeFile } = service;
    return uploadResumeFile(file, replaceData);
  }

  onShowAlert = () => {
    this.setState({ showAlert: true });
  }

  onAlertClose = () => {
    this.setState({ showAlert: false });
  }

  clearCurrentData = () => {
    const { service } = this.props;
    const { clearCurrentResumeData } = service;
    return clearCurrentResumeData();
  }

  onUploadedResumeView = () => {
    const { service } = this.props;
    const { PersonalInformation } = service.state;
    const resume = PersonalInformation.resume || '';
    if (resume) {
      window.open(`${getGCSUrl()}/resume/${resume}`, '__blank');
    } else {
      message.info('No uploaded resume found');
    }
  }

  render() {
    const { service, currentDelight, LDFlags } = this.props;
    const { save } = service;
    const { saved, CloudCertifications } = service.state;
    const { store } = service.props;
    const { enable_language_quiz } = LDFlags;
    const { activePanel } = this.state
    const { isEmbed, isReadOnly } = service.props;
    let BadgeComponent = null;
    let BadgeComponentType = null;
    if (Array.isArray(CloudCertifications) && CloudCertifications.length > 0) {
      const pendingCertification = CloudCertifications.find(x => x.verification_status === CERTIFICATION_STATUS.NEEDS_INFO);
      if (pendingCertification) {
        BadgeComponentType = pendingCertification.verification_status;
        BadgeComponent = StatusBadge;
      }
    }
    const shouldShowDelight = currentDelight === "completedProfile" && !service.hasFastrackFlow();

    return (
      <div className="FinalizeResumeV2">
        <div className="FinalizeResumeV2-leftcol">
          {isEmbed ? null : (
            <>
              <div className="FinalizeResumeV2-title">
                <h1>Finalize Profile</h1>
                <PreviewProfileButton service={service} />
              </div>
              <p className="FinalizeResumeV2-p">Congratulations on clearing the Tests! The details entered here will be presented to the companies. Complete your profile and grab the attention of employers and recruiters. Don&apos;t forget to preview as you progress to see how your Profile will be presented to the companies.</p>
              <TuringCollapseAB enableLanguageQuiz={enable_language_quiz} currentActivePanel={activePanel} ref={this.panelRefs.personalinformation} title="Personal Information" spicon={<PersonalIcon />} name="PersonalInformation" service={service}>
                <PersonalInformationForm service={service} />
              </TuringCollapseAB>
            </>
          )}
          <TuringCollapseAB enableLanguageQuiz={enable_language_quiz} currentActivePanel={activePanel} ref={this.panelRefs.workhistory} title="Work History" spicon={<WorkExperienceIcon />} name="WorkHistory" service={service}>
            <WorkHistoryForm service={service} />
          </TuringCollapseAB>
          <TuringCollapseAB enableLanguageQuiz={enable_language_quiz} currentActivePanel={activePanel} ref={this.panelRefs.sideprojects} title="Side Projects" spicon={<FolderOpenIcon />} name="SideProjects"service={service}>
            <SideProjectsForm service={service} />
          </TuringCollapseAB>
          {isEmbed ? null : (
            <TuringCollapseAB enableLanguageQuiz={enable_language_quiz} currentActivePanel={activePanel} ref={this.panelRefs.education} title="Education" spicon={<SchoolIcon />} name="Education" service={service}>
              <EducationForm service={service} />
            </TuringCollapseAB>
          )}
          <TuringCollapseAB enableLanguageQuiz={enable_language_quiz} currentActivePanel={activePanel} ref={this.panelRefs.languages} title="Languages" spicon={<LanguagesIcon />} name="languages" service={service}>
            <LanguagesForm service={service} />
          </TuringCollapseAB>
          <TuringCollapseAB enableLanguageQuiz={enable_language_quiz} currentActivePanel={activePanel} ref={this.panelRefs.additionalinformation} title="Additional Information" spicon={<ScatterPlotIcon />} name="AdditionalInformation" service={service} StatusBadgeComponent={BadgeComponent} StatusBadgeType={BadgeComponentType}>
            <AdditionalInformationForm service={service} />
          </TuringCollapseAB>
          {saved ? <Alert type="success" message="Successfully saved" /> : (isReadOnly ? null
            : <Row type="flex" justify="end" style={{ gap: "10px" }}>
              <Button type="primary" ghost onClick={this.onUploadedResumeView} className='view-uploaded-resume-btn'><span className="material-icons" style={{ color: '#2E6EDF', fontSize: '18.33px', marginRight: 10 }}>visibility</span>View Uploaded Resume</Button>
              <Button className="FinalizeResumeV2-submit" type="primary" onClick={() => {
                changePreviousDevData(store.tests.turingProfileCompleted, 'turingProfileCompleted');
                save();
              }}><SaveIcon />Save Profile</Button>
            </Row>
          )}
          {this.state.showAlert ? <ResumeUploadedConfirmation onAlertClose={this.onAlertClose} /> : null}
          {/* <ResumePanel clearCurrentData={this.clearCurrentData} onShowAlert={this.onShowAlert} uploadResume={this.uploadResume} /> */}
        </div>
        {isEmbed ? null : (
          <div className="FinalizeResumeV2-rightcol">
            <RequiredActionCollapse service={service} />
          </div>
        )}
        {shouldShowDelight && <Matchable />}
      </div>
    );
  }
}

const TuringCollapseAB = forwardRef((props, ref) => {
  if (props.enableLanguageQuiz) {
    const isActive = (props.currentActivePanel || '').toLowerCase() === (props.name || '').toLowerCase();
    return (
      <TuringCollapseV2 ref={ref} active={isActive} {...props}>
        {props.children}
      </TuringCollapseV2>
    )
  }
  return (
    <TuringCollapse title={props.title} spicon={props.spicon} name={props.name} service={props.service}>
      {props.children}
    </TuringCollapse>
  )
})

FinalizeResumeV2.propTypes = {
  children: PropTypes.any,
  service: PropTypes.any,
  mcq_use_apiv1: PropTypes.bool,
};

const withDelightToShow = (Component) => (props) => {
  const { store } = props.service.props;
  const currentDelight = delightToShow(store.home, store.tests, props.mcq_use_apiv1);
  return <Component {...props} currentDelight={currentDelight} />;
};

export default withFinalizeResumeV2Service(withDelightToShow(withLDFlagsFromBackend(FinalizeResumeV2, [GB_FLAGS.enable_language_quiz])));
